import { useCallback, useEffect, useRef, useState } from "react";

export default function useCardSlider(
  itemCount,
  paused = false,
  delay = 5000,
  groupSlides = false
) {
  const [visibleCount, setVisibleCount] = useState(3);
  const [startIndex, setStartIndex] = useState(0);
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const touchStart = useRef(null);
  const blockClick = useRef(false);

  useEffect(() => {
  const updateVisibleCount = () => {
    const width = window.innerWidth;

    if (width < 768) {
      setVisibleCount(1);
    } else if (width < 1024) {
      setVisibleCount(2);
    } else {
      setVisibleCount(3);
    }
  };

  updateVisibleCount();

  window.addEventListener("resize", updateVisibleCount);

  return () => {
    window.removeEventListener("resize", updateVisibleCount);
  };
}, []);

  const maxIndex = groupSlides
  ? Math.max(0, Math.ceil(itemCount / visibleCount) - 1) * visibleCount
  : Math.max(0, itemCount - visibleCount);
  useEffect(() => {
    setStartIndex((i) => Math.min(i, maxIndex));
  }, [maxIndex]);

  const next = useCallback(() => {
  setStartIndex((i) => {
    if (!groupSlides) {
      return i >= maxIndex ? 0 : i + 1;
    }

    const nextIndex = i + visibleCount;
    return nextIndex >= itemCount ? 0 : nextIndex;
  });
}, [groupSlides, maxIndex, visibleCount, itemCount]);

const prev = useCallback(() => {
  setStartIndex((i) => {
    if (!groupSlides) {
      return i <= 0 ? maxIndex : i - 1;
    }

    if (i <= 0) {
      return Math.floor((itemCount - 1) / visibleCount) * visibleCount;
    }

    return Math.floor((i - 1) / visibleCount) * visibleCount;
  });
}, [groupSlides, maxIndex, visibleCount, itemCount]);

  const reset = useCallback(() => setStartIndex(0), []);

  

  const onTouchStart = (e) => {
    const t = e.touches[0];
    touchStart.current = { x: t.clientX, y: t.clientY };
    blockClick.current = false;
  };
  const onTouchEnd = (e) => {
    if (!touchStart.current) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - touchStart.current.x;
    const dy = t.clientY - touchStart.current.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      blockClick.current = true;
      dx < 0 ? next() : prev();
    }
    touchStart.current = null;
  };
  const onClickCapture = (e) => {
    if (blockClick.current) {
      e.preventDefault();
      e.stopPropagation();
      blockClick.current = false;
    }
  };

  return {
    startIndex, setStartIndex, visibleCount, maxIndex, next, prev, reset,
    sliderProps: {
      onTouchStart, onTouchEnd, onClickCapture,
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      onFocusCapture: () => setFocused(true),
      onBlurCapture: (e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) setFocused(false);
      }
    }
  };
}
